import { useQuery } from "react-query";
import {
	fetchCommandEarmoldTypesStatus,
	fetchCommandStatsCenters,
	fetchCommandStatsStatus,
	fetchCommandStatsStatusHalted,
	fetchCommandTreatmentTimeStatus,
	fetchCommandTypesStatus,
	fetchTicketTypesStatus,
} from "../queries/stat.queries";
import type { StatsFilterProps } from "../types/stats.types";

export const useCommandsStatusStats = (filters: StatsFilterProps) => {
	return useQuery({
		queryKey: ["commands", "stats", "status", filters.date],
		queryFn: () => {
			return fetchCommandStatsStatus(filters);
		},
	});
};

export const useCommandsStatusStatsHalted = (filters: StatsFilterProps) => {
	return useQuery({
		queryKey: ["commands", "stats", "status", "halted", filters.date],
		queryFn: () => {
			return fetchCommandStatsStatusHalted(filters);
		},
	});
};

export const useCommandsTreatmentTimeStats = (filters: StatsFilterProps) => {
	return useQuery({
		queryKey: [
			"stats",
			"commands",
			"treatment",
			"time",
			filters.date,
			filters.interval,
			filters.enterprises,
			filters.centers,
		],
		queryFn: () => {
			return fetchCommandTreatmentTimeStatus(filters);
		},
	});
};

export const useCommandsTypesStats = (filters: StatsFilterProps) => {
	return useQuery({
		queryKey: ["stats", "commands", "types", filters.date],
		queryFn: () => {
			return fetchCommandTypesStatus(filters);
		},
	});
};

export const useCommandsEarmoldTypesStats = (filters: StatsFilterProps) => {
	return useQuery({
		queryKey: ["stats", "commands", "earmold", "types", filters.date],
		queryFn: () => {
			return fetchCommandEarmoldTypesStatus(filters);
		},
	});
};

export const useCommandsCentersStats = (filters: StatsFilterProps) => {
	return useQuery({
		queryKey: ["stats", "commands", "centers", filters.date],
		queryFn: () => {
			return fetchCommandStatsCenters(filters);
		},
	});
};

export const useTicketsTypesStats = (filters: StatsFilterProps) => {
	return useQuery({
		queryKey: ["stats", "tickets", "types", filters.date],
		queryFn: () => {
			return fetchTicketTypesStatus(filters);
		},
	});
};
